/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Button, Tooltip, Row, Col, Modal, Select } from 'antd';
import GridView from '../../../components/elements/GridView/index';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import { Erase } from '@carbon/icons-react';
import history from '../../../core/utils/history';

export default function () {
    const {
        asset,
        selectedAssets,
        actions,
        isExportingCsv,
        companyTags,
    } = this.props;
    const {
        data, showTagsModal, selectedTagsToAssign, tagsAssignErrorMessage,
    } = this.state;

    let sortableColumns = [];
    if (data && data[0]) {
        sortableColumns = Object.keys(data[0]).filter((o) => !['actions', 'action', 'select', 'last_location'].includes(o));
    }
    const noAssetsSelected = selectedAssets.length === 0;
    const disableReason = 'Please select at least one asset';

    const onOk = () => {
        if (!selectedTagsToAssign) {
            this.setState({ tagsAssignErrorMessage: 'Please select at least one tag!' });
            return;
        }

        this.setState({ tagsAssignErrorMessage: '' });
        actions.assignTagsToAssetsRequest({
            asset_ids: selectedAssets,
            tag_ids: selectedTagsToAssign,
        });
        this.setState({ showTagsModal: false });
    };

    const onCancel = () => {
        this.setState({ showTagsModal: false });
    };

    return (
        <div className="assets-tab">
            <Row style={{
                maxWidth: "80%",
                position: 'absolute', 
                right: '20px',
            }}>
                <Col
                    span={24}
                    style={{
                        textAlign: 'right',
                        top: '-30px',
                        right: 0,
                    }}
                >
                    <Tooltip
                        title={noAssetsSelected ? disableReason : ''}
                        open={noAssetsSelected ? undefined : false}
                    >
                        <Button
                            type="primary"
                            className="mr-2"
                            onClick={() => actions.clearSelectedAssets()}
                            disabled={noAssetsSelected}
                            data-testid='assets_clear-selection-btn'
                        >
                            Clear selection
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title={noAssetsSelected ? disableReason : ''}
                        open={noAssetsSelected ? undefined : false}
                    >
                        <Button
                            type="primary"
                            className="mr-2"
                            onClick={() => {
                                const checkedAssets = selectedAssets.map(assetId => `asset-${assetId}`);
                                actions.setCheckedAssets(checkedAssets);
                                history.push('/map');
                            }}
                            disabled={noAssetsSelected}
                            data-testid='assets_view-on-map-btn'
                        >
                            View on Map
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title={noAssetsSelected ? disableReason : ''}
                        open={noAssetsSelected ? undefined : false}
                    >
                        <Button
                            type="primary"
                            className="mr-2"
                            onClick={() => this.setState({ showTagsModal: true })}
                            disabled={noAssetsSelected}
                            data-testid='assets_assign-tags-btn'
                        >
                            Assign Tags
                        </Button>
                    </Tooltip>
                    <Button
                        type="primary"
                        onClick={this.handleExport}
                        loading={isExportingCsv}
                        data-testid='assets_export-btn'
                    >
                        Export
                    </Button>
                </Col>
            </Row>

            <div className="assets-grid">
                <GridView
                    data={data}
                    onChange={this.handleTableChange}
                    sortableColumns={sortableColumns}
                    hiddenColumns={['id']}
                    pagination={{
                        total: asset.pagination.totalCount,
                        pageSize: asset.pagination.perPage,
                        showSizeChanger: false,
                        onChange: (page) => this.paginationChange(page),
                        current: asset.pagination.currentPage,
                        showTotal: getPaginationTotal,
                    }}
                />
            </div>

            <Modal
                open={showTagsModal}
                onCancel={onCancel}
                onOk={onOk}
                okText="Assign"
            >
                <h3 className='title'>Select Tags to Assign</h3>
                <br />
                <div>
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Tags"
                        allowClear={<Erase size={12} />}
                        showSearch
                        data-testid='assign-tags-modal_tag-select'
                        style={{ width: '100%' }}
                        value={selectedTagsToAssign}
                        onChange={val => this.setState({ selectedTagsToAssign: val, tagsAssignErrorMessage: '' })}
                    >
                        {companyTags.tagList.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                {tagsAssignErrorMessage && <div style={{ color: 'red', textAlign: 'center', marginTop: '4px' }}>{tagsAssignErrorMessage}</div>}
                <br />
            </Modal>
        </div>
    );
}
